const router =
 [
	  {
	    path: '/',
	    name: 'home',
	    component: () => import('../views/home.vue'),
	    meta: {
	      title: '汇金永信保险销售服务有限公司',
	      index: 1
	    },
	  },
	  {
	    path: '/news',
	    name: 'news',
	    component: () => import('../views/news.vue'),
	    meta: {
	      title: '汇金永信保险销售服务有限公司-新闻列表',
	      index: 1
	    },
	  },
	  {
	    path: '/detals',
	    name: 'detals',
	    component: () => import('../views/detals.vue'),
	    meta: {
	      title: '汇金永信保险销售服务有限公司-详情',
	      index: 1
	    },
	  },
	  {
	    path: '/read',
	    name: 'read',
	    component: () => import('../views/detals2.vue'),
	    meta: {
	      title: '汇金永信保险销售服务有限公司-详情',
	      index: 1
	    },
	  },
	  {
		  path: '/index2',
		  name: 'index2',
		  component: () => import('../views/index2.vue'),
		  meta: {
		    title: '汇金永信保险销售服务有限公司-新闻列表',
		    index: 1
		  },
	  },
	  {
	    path: '/map',
	    name: 'map',
	    component: () => import('../views/map.vue'),
	    meta: {
	      title: '汇金永信保险销售服务有限公司-地图',
	      index: 1
	    },
	  },
	  {
	    path: '/us',
	    name: 'us',
	    component: () => import('../views/us.vue'),
	    meta: {
	      title: '汇金永信保险销售服务有限公司',
	      index: 1
	    },
	},
	{
	    path: '/m/index',
	    name: 'm_index',
	    component: () => import('../views/moble/index.vue'),
	    meta: {
	      title: '汇金永信保险销售服务有限公司',
	      index: 1
	    },
	},
	{
	    path: '/m/us',
	    name: 'm_us',
	    component: () => import('../views/moble/us.vue'),
	    meta: {
	      title: '关于汇金',
	      index: 1
	    },
	},
	{
	    path: '/m/list',
	    name: 'm_list',
	    component: () => import('../views/moble/list.vue'),
	    meta: {
	      title: '汇金永信保险销售服务有限公司新闻',
	      index: 1
	    },
	},
	{
	    path: '/m/map',
	    name: 'm_map',
	    component: () => import('../views/moble/map.vue'),
	    meta: {
	      title: '汇金永信保险销售服务有限公司-联系方式',
	      index: 1
	    },
	},
	{
	    path: '/m/detal',
	    name: 'm_detal',
	    component: () => import('../views/moble/detal.vue'),
	    meta: {
	      title: '汇金永信保险销售服务有限公司',
	      index: 1
	    },
	},
    {
      path: '/:catchAll(.*)',
      name: '404',
      component: () => import('../views/404.vue'),
    },
  ]

export default router